import React, { useRef, useState, useEffect } from "react";
import { Button } from "reactstrap";

import "../PrintFlyer.css";

import { Col, Row } from "reactstrap";

const FoodSection = ({ data }) => {
  return (
    <>
      {data.map((e, index) => (
        <div
          key={index}
          className={` col-6 ${index % 2 == 0 ? " ps-4" : "pe-4 "}`}
        >
          <div className="foodSection position-relative pt-5  ">
            <div className=" position-absolute foodImg">
              <img src={e.FoodImg} alt="foodimg" height={80} width={100} className="rounded-circle" />
            </div>

            <div className="title ">{e.FoodTitle}</div>

            <div className="description my-2 px-1">{e.FoodDescription}</div>

            <div className="price mt-3">Rs. {e.FoodPrice}</div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FoodSection;
